import { VimeoFrame } from "src/utils/fw";

export default {
    background: "https://assets.swoogo.com/uploads/full/3026750-65241375cf698.png",
    links: [
        {
            label: "KPMG Website",
            href: "https://kpmg.com/xx/en/home.html",
            width: "15.7%",
            height: "18.1%",
            left: "74.7%",
            top: "10%",
            cursor: "pointer",
            target:"_blank"
        },
        {
            label: "KPMG Logo",
            href: "https://kpmg.com/xx/en/home.html",
            width: "10%",
            height: "9.9%",
            left: "27.4%",
            top: "31.8%",
            cursor: "pointer",
            target:"_blank"

        },
        {
            label: "KPMG Global Tech Report 2023",
            href: "https://assets.swoogo.com/uploads/3043498-6527f0d713e3a.pdf",
            width: "7.5%",
            height: "19.2%",
            left: "46.2%",
            top: "36.9%",
            cursor: "pointer",
            target:"_blank"

        },
        {
            label: "Contact Us",
            href: "mailto:bakker.marijn@kpmg.nl",
            width: "8.3%",
            height: "16.2%",
            left: "12%",
            top: "67.9%",
            isExternal: true,
            target:"_blank"
        },
        {
            label: "Privacy in the World of AI Report",
            href: "https://assets.swoogo.com/uploads/3043497-6527f0d5991b2.pdf",
            width: "8.6%",
            height: "16%",
            left: "24.7%",
            top: "67.8%",
            cursor: "pointer",
            target:"_blank"

        },
        {
            label: "Cybersecurity in ESG Report",
            href: "https://assets.swoogo.com/uploads/3043499-6527f0db90fbe.pdf",
            width: "5.9%",
            height: "14.3%",
            left: "47.1%",
            top: "65.3%",
            cursor: "pointer",
            target:"_blank"

        },
        {
            label: "KPMG Video",
            width: "14.6%",
            height: "16.7%",
            left: "75.2%",
            top: "45.2%",
            cursor: "pointer",
            modal: <VimeoFrame wrapperStyle={{ backgroundColor: "rgb(59, 80, 206)" }} vidId="873866710?h=5a2897783f&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479"/>
        },
        {
            label: "Previous Room",
            href: "/exhibition-hall-silver-bronze",
            width: "17%",
            height: "8.0%",
            left: "23.3%",
            top: "89.0%",
        },
        {
            label: "Next Room",
            href: "/exhibition-hall-platinum",
            width: "17.0%",
            height: "8%",
            left: "58.9%",
            top: "89.6%",
        },
        {
            label: "Back To Main Hall",
            href: "/exhibition-hall",
            width: "18.2%",
            height: "8%",
            left: "40.8%",
            top: "89.3%",
        },
    ],
    name: "exhibition-hall-diamond",
}